import { AddressFieldInfo } from "./address-field-info.class";

export class DropdownAddressFieldInfo extends AddressFieldInfo {
    options: { value: string; label: string }[] = [];
}
